<label *ngIf="consentTemplate" class="eb-consent-management-form__label">
  <input
    type="checkbox"
    (change)="onConsentChange()"
    [checked]="consentGiven"
    [disabled]="isRequired(consentTemplate.id) || (isActiveAsmAgent() | async)"
    class="eb-consent-management-form__input"
  />
  {{ consentTemplate.name }}
</label>
<div
  [innerHTML]="consentTemplate.description"
  class="eb-consent-management-form__description"
></div>
